declare let THREE: any;

export class Edge extends (THREE.Mesh as { new(geometry, material): any; }) {

  readonly edge: Feeney.IEdge;

  constructor(length: number, edge: Feeney.IEdge) {
    const transformation = new THREE.Matrix4().makeTranslation(length / 2, 0, 0)
      .multiply(new THREE.Matrix4().makeRotationX(THREE.Math.degToRad(-90)));
    const geometry = new THREE.PlaneBufferGeometry(length, 10).applyMatrix(transformation);
    const material = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
      color: 0x0000ff,
      transparent: true,
      opacity: 0.5
    });
    super(geometry, material);
    this.edge = edge;
    this.visible = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Edge/index.ts